import { useWeb3Store } from "@/store/web3";
import { TokenType } from "@/config/token-types";
import utilitiesMetadata from "@/config/utilities-metadata";

export const fetchUtilities = async (utilitiesBalance) => {
  const incubators = await loadIncubators(Number(utilitiesBalance[0]));
  const orbs = await loadOrbs(Number(utilitiesBalance[1]));
  /*
      utility #20 - 23 METH MAKER (20 North, 21 South, 22 East, 23 West)
      utility #30 - 33 RESURRECTION
      utility #40 - 43 BREED REPLENISH
  */
  const teenResurrections = await loadGamingUtilities(
    [6, 7, 8, 9].map((item) => +utilitiesBalance[item]),
    [30, 31, 32, 33],
    TokenType.TEEN_RESURRECTION
  );
  const breedingReplenishments = await loadGamingUtilities(
    [10, 11, 12, 13].map((item) => +utilitiesBalance[item]),
    [40, 41, 42, 43],
    TokenType.BREEDING_REPLENISHMENT
  );

  const methMachines = await loadGamingUtilities(
    [2, 3, 4, 5].map((item) => +utilitiesBalance[item]),
    [20, 21, 22, 23],
    TokenType.METH_MACHINE
  );

  return {
    methMachines,
    breedingReplenishments,
    teenResurrections,
    orbs,
    incubators,
  };
};

async function loadIncubators(count) {
  if (!count) {
    return [];
  }
  const metadata = utilitiesMetadata[1];
  const incubators = [];
  for (let i = 0; i < count; i++) {
    incubators.push({
      id: 1,
      isUtility: true,
      type: TokenType.INCUBATOR,
      ...metadata,
    });
  }
  return incubators;
}

async function loadOrbs(count) {
  if (!count) {
    return [];
  }
  const metadata = utilitiesMetadata[2];
  const orbs = [];
  for (let i = 0; i < count; i++) {
    orbs.push({
      id: 2,
      isUtility: true,
      type: TokenType.MERGER_ORB,
      ...metadata,
    });
  }
  return orbs;
}

async function loadGamingUtilities(counts, ids, type) {
  const items = [];

  for (let i = 0; i < counts.length; i++) {
    for (let j = 0; j < counts[i]; j++) {
      // const guildIndex = ids[i] % mainId;
      const metadata = utilitiesMetadata[ids[i]];
      // const guild = guildIndexes[guildIndex];
      items.push({
        // id: mainId,
        // subid: ids[i],
        id: ids[i],
        isUtility: true,
        type,
        ...metadata,
      });
    }
  }
  return items;
}
